import request from '../utils/request';
import { buildApiPayload } from '../utils/api';

export function getStockOutReports(params, signal) {
  return request({
    url: '/stockOut/list',
    method: 'get',
    data: buildApiPayload({ payload: params, dateEndKeys: ['endTime'] }),
    signal,
  });
}

export function getStockOutTotal(params, signal) {
  return request({
    url: '/stockOut/total',
    method: 'get',
    data: buildApiPayload({ payload: params, dateEndKeys: ['endTime'] }),
    signal,
  });
}

export function getExcelExport(params) {
  return request({
    url: '/stockOut/xls',
    method: 'get',
    data: buildApiPayload({ payload: params, dateEndKeys: ['endTime'] }),
    responseType: 'arraybuffer',
  });
}

export function getAnalytics(params, signal) {
  return request({
    url: '/stockOut/analytic',
    method: 'get',
    data: buildApiPayload({ payload: params, dateEndKeys: ['endTime'] }),
    signal,
  });
}
